import React, { useState } from 'react'
import './Portfolio.css';
import ProjectModal from './ProjectModal';
import Github from '../../assets/Github.png';
import WeatherApp from '../../assets/weather-project.png';
import NoteVault from '../../assets/notevault.png';
import NewsPulse from '../../assets/newspulse.png';
import MovieApp from '../../assets/movieapp.png';
import TextWizard from '../../assets/textwizard.png';
import EcommerceStore from '../../assets/ecommerceStore.jpg';
import TechfolioReact from '../../assets/react-techfolio.png';
import SimpleResume from '../../assets/resume.png';
import HealthCareSystem from '../../assets/HealthCareSystem.png';
import AIPricingCalculator from '../../assets/AI-Pricing-Calculator-Full-Stack-Next-JS.png';
import AdvanceMiningSolutions from '../../assets/Advance-Mining-Solutions-Tough-Cables-for-Tough-Conditions.png';

// Add your automation/AI project thumbnails
import NorbuAgent from '../../assets/norbu-agent.png';
import CycleWise from '../../assets/cyclewise.png';
import InternalLeadGen from '../../assets/n8n-Internal-Lead-Generation-Automation-Flow.png';
import RealEstateAgent from '../../assets/Real-Estate-AI-Agent-n8n-automation.png';
import NicoleDonnellyAgent from '../../assets/Nicole-Donelly-Chatbot-Agent-Automation.png';

// New project thumbnails
import RemapClientPortal from '../../assets/Remap-Client-Portal.jpg';
import RemapOperationPlatform from '../../assets/Remap-Operation-Dashboard-Image.png';
import LeadReviveAI from '../../assets/Lead-Revive-AutomationFlow-Image.png';
import PrivateAIWebsite from '../../assets/private-ai-website.svg';
import RemapAIWebsite from '../../assets/remap-ai-website.svg';

// Import icons for consistent design
import { FaGithub } from "react-icons/fa";
import { FaExternalLinkAlt } from "react-icons/fa";
import { FaRegFileAlt } from "react-icons/fa";


const data = [
   // --- Latest project first ---
   {
      id: 22,
      image: RemapClientPortal,
      title: 'REMAP AI Client Engagement Platform',
      github: '#',
      demo: 'https://clients.remap.ai/self-serve',
      category: 'Full Stack Apps',
      details: {
         problem: 'REMAP needed one place where clients could onboard themselves and manage their engagements, while the internal team needed an admin view to oversee every account.',
         role: 'I built both sides of the platform end to end: a self-serve client portal and a separate admin portal, covering authentication, database design, the API layer, and the full responsive UI.',
         outcome: 'Clients can now onboard and manage their work without manual back and forth, and the team runs operations from a single dashboard.',
         stack: ['Next.js', 'PostgreSQL', 'Prisma', 'Node.js', 'REST APIs', 'Tailwind CSS'],
      },
   },
   {
      id: 21,
      image: RemapOperationPlatform,
      title: 'Remap AI Outsourcing Platform',
      github: 'https://github.com/REMAPai/remap-operation/tree/development',
      demo: 'https://operation.remap.ai/',
      category: 'Full Stack Apps',
      details: {
         problem: 'Managing outsourced AI delivery across many clients was spread across spreadsheets and chat, with no single source of truth.',
         role: 'I developed an internal operations platform to manage projects, teams, and delivery status in one place, with role-based access for staff.',
         outcome: 'The team gets a clear view of every active engagement and its status, which cuts down coordination overhead.',
         stack: ['Next.js', 'PostgreSQL', 'Node.js', 'REST APIs'],
      },
   },
   {
      id: 20,
      image: RemapAIWebsite,
      title: 'REMAP.ai AI Consultancy Website',
      github: '#',
      demo: 'https://remap.ai/',
      category: 'WordPress',
      details: {
         problem: 'REMAP needed a polished marketing site to present its AI consultancy services and convert visitors into leads.',
         role: 'I built and maintained the company website, focusing on clean structure, fast load times, and clear calls to action.',
         outcome: 'A professional web presence that represents the brand and captures inbound enquiries.',
         stack: ['WordPress', 'Custom Theme', 'SEO'],
      },
   },
   {
      id: 19,
      image: PrivateAIWebsite,
      title: 'Private AI Secure Enterprise AI Platform',
      github: '#',
      demo: 'https://useprivate.ai/',
      category: 'WordPress',
      details: {
         problem: 'Private AI needed a site that communicates a secure, enterprise-grade AI platform to a technical audience.',
         role: 'I developed the website and tuned the layout and content presentation for clarity and trust.',
         outcome: 'A clear, credible site that positions the product for enterprise buyers.',
         stack: ['WordPress', 'Custom Theme', 'SEO'],
      },
   },
   {
      id: 18,
      image: LeadReviveAI,
      title: 'Lead Revive AI Multi-Channel Outreach Automation',
      github: '#',
      demo: '#',
      category: 'AI & Automation',
      details: {
         problem: 'Cold and dormant leads were going to waste because there was no consistent, multi-channel follow up.',
         role: 'I built an automation that re-engages leads across email, SMS, and voice, with AI-generated messaging tuned to each lead.',
         outcome: 'Dormant leads get worked automatically, so the sales team focuses only on warm replies.',
         stack: ['n8n', 'OpenAI', 'Twilio', 'Email APIs'],
      },
   },
   {
      id: 17,
      image: AdvanceMiningSolutions,
      title: 'Advanced Mining Solution Full Stack App',
      github: 'https://github.com/syedmuhammadmaaz/AMSMining',
      demo: 'https://advanced-mining-solutio-git-db96de-syed-muhammad-maazs-projects.vercel.app/',
      category: 'Full Stack Apps',
      details: {
         problem: 'An industrial cable supplier needed a proper web app to present its product range and handle enquiries.',
         role: 'I built the full-stack application, from the product catalogue and data model through to the responsive front end.',
         outcome: 'A working product platform the business can show customers and grow.',
         stack: ['React', 'Node.js', 'Express', 'MongoDB'],
      },
   },
   {
      id: 8,
      image: AIPricingCalculator,
      title: 'AI-Pricing Quote Calculator App',
      github: 'https://github.com/syedmuhammadmaaz/AI-Pricing-Calculator',
      demo: 'https://ai-pricing-calculator.vercel.app/',
      category: 'Full Stack Apps',
      details: {
         problem: 'Getting a project quote usually means waiting for a human to reply, which loses leads who want an answer now.',
         role: 'I built a Next.js app that asks a few questions and uses AI to generate an instant, itemised price estimate.',
         outcome: 'Visitors get an immediate quote, which captures interest at the exact moment it is highest.',
         stack: ['Next.js', 'OpenAI', 'React', 'REST APIs'],
      },
   },
   // --- Existing automation/AI projects ---
  {
   id: 16,
   image: NicoleDonnellyAgent,
   title: 'Nicole Donnelly |Cyclewise |Custom AI Agent',
   github: '#',
   demo: '#',
   category: 'AI & Automation',
   details: {
      problem: 'A client needed a custom AI agent to handle repetitive customer conversations without growing their team.',
      role: 'I designed and deployed a tailored conversational agent wired into their existing workflow and tools.',
      outcome: 'Routine queries are handled automatically, freeing the client to focus on higher-value work.',
      stack: ['OpenAI', 'n8n', 'Webhooks'],
   },
 },
 {
   id: 15,
   image: RealEstateAgent,
   title: 'Real Estate AI Agent:(SMS,Voice)',
   github: '#',
   demo: '#',
   category: 'AI & Automation',
   details: {
      problem: 'Real estate leads expect fast responses on their channel of choice, day or night.',
      role: 'I built an AI agent that handles inbound and outbound conversations over SMS and voice, qualifying leads and booking appointments.',
      outcome: 'Leads get an instant response and qualified prospects reach the agent\'s calendar automatically.',
      stack: ['OpenAI', 'ElevenLabs', 'Twilio', 'n8n'],
   },
 },
 {
   id: 14,
   image: InternalLeadGen,
   title: 'Cold Email Marketing Lead Generation(LinkedIn)',
   github: '#',
   demo: '#',
   category: 'AI & Automation',
   details: {
      problem: 'Building a steady outbound pipeline by hand is slow and inconsistent.',
      role: 'I built an automation that sources leads from LinkedIn and runs personalised cold email outreach at scale.',
      outcome: 'A repeatable outbound engine that keeps the top of the funnel full.',
      stack: ['n8n', 'OpenAI', 'LinkedIn', 'Email APIs'],
   },
 },
 {
   id: 13,
   image: CycleWise,
   title: 'CycleWise AI Health App',
   github: 'https://github.com/syedmuhammadmaaz/',
   demo: 'https://cycle-wise-ai.vercel.app/',
   category: 'AI & Automation',
   details: {
      problem: 'Women tracking their cycle want clear, private insights, not just raw data.',
      role: 'I built an AI-powered health app that tracks cycles and turns the data into helpful, easy-to-read guidance.',
      outcome: 'Users get personalised insights in plain language.',
      stack: ['React', 'OpenAI', 'Node.js'],
   },
 },
 {
   id: 12,
   image: NorbuAgent,
   title: 'Norbu Legal Marketing Agent',
   github: '#',
   demo: '#',
   category: 'AI & Automation',
   details: {
      problem: 'A legal marketing firm needed to handle inbound and outbound contact across several channels without growing headcount.',
      role: 'I built a multi-channel agent covering inbound, outbound, and SMS, with an AI receptionist to greet and route callers.',
      outcome: 'Calls and messages are answered and routed automatically, around the clock.',
      stack: ['OpenAI', 'ElevenLabs', 'Twilio', 'n8n'],
   },
 },
   {
      id: 11,
      image: HealthCareSystem,
      title: 'HealthEase-System',
      github: 'https://github.com/syedmaazsaeed/HealthEase-System',
      demo: 'https://github.com/syedmaazsaeed/HealthEase-System',
      category: 'C# Windows App'
   },
   {
      id: 10,
      image: SimpleResume,
      title: 'Developer Portfolio',
      github: 'https://github.com/syedmaazsaeed/tech-portfolio',
      demo: 'https://syedmaazsaeed-portfolio.netlify.app/',
      category: 'Front-End'
   },
   {
      id: 9,
      image: TechfolioReact,
      title: 'Techfolio-React ',
      github: 'https://github.com/syedmaazsaeed/Techfolio-React',
      demo: 'https://techfolio-react-portfolio.netlify.app/',
      category: 'Front-End'
   },
   {
      id: 7,
      image: EcommerceStore,
      title: 'EcommerceShopifyStore-reactApp',
      github: 'https://github.com/syedmaazsaeed/EcommerceShopifyStore-reactApp',
      demo: 'https://ecommerce-shopify-store.netlify.app/',
      category: 'Full Stack Apps'
   },
   {
      id: 6,
      image: TextWizard,
      title: 'ReactJS-WordCounter',
      github: 'https://github.com/syedmaazsaeed/ReactJS-WordCounter',
      demo: 'https://mytextwizard.netlify.app/',
      category: 'Front-End'
   },
   {
      id: 5,
      image: MovieApp,
      title: 'React-Movie-Search',
      github: 'https://github.com/syedmaazsaeed/React-Movie-Search',
      demo: 'https://react-movie-search-app.netlify.app/',
      category: 'Front-End'
   },
   {
      id: 4,
      image: NewsPulse,
      title: 'React-NewsPulse-App',
      github: 'https://github.com/syedmaazsaeed/React-NewsPulse-App',
      demo: 'https://newspulse-react-app.netlify.app/',
      category: 'Front-End'
   },
   {
      id: 3,
      image: NoteVault,
      title: 'NoteVaultPro-MernApp',
      github:'https://github.com/syedmaazsaeed/NoteVaultPro-MernApp',
      demo: 'https://inotebookstore-app.netlify.app/',
      category: 'Full Stack Apps'
   },
   {
      id: 2,
      image: WeatherApp,
      title: 'ForecastFusion-Weather-App',
      github: 'https://github.com/syedmaazsaeed/ForecastFusion-Weather-App',
      demo: 'https://forecastfusion-app.netlify.app/',
      category: 'Front-End'
   },
   {
      id: 1,
      image: Github,
      title: 'Github-CodeSource-FullStack-App',
      github: 'https://github.com/syedmaazsaeed/Github-CodeSource-FullStack-App',
      demo: 'https://github-codesource-app.netlify.app/',
      category: 'Full Stack Apps'
   }
]




const Portfolio = () => {

   const [filter, setFilter] = useState('All');
   const [filteredProjects, setFilteredProjects] = useState(data);
   const [activeProject, setActiveProject] = useState(null);

   // Filter projects based on category
   const handleFilterClick = (category) => {
      setFilter(category);
      if (category === 'All') {
         setFilteredProjects(data);
      } else {
         setFilteredProjects(data.filter(project => project.category === category));
      }
   }

   return (
     <section id='portfolio'>
       <h5>My Recent Work</h5>
       <h2>Portfolio</h2>

       {/* Filter Buttons */}
       <div className="portfolio__filters">
          <button onClick={() => handleFilterClick('All')} className={filter === 'All' ? 'active' : ''}>All</button>
          <button onClick={() => handleFilterClick('Full Stack Apps')} className={filter === 'Full Stack Apps' ? 'active' : ''}>Full Stack Apps</button>
          <button onClick={() => handleFilterClick('Front-End')} className={filter === 'Front-End' ? 'active' : ''}>Frontend</button>
          <button onClick={() => handleFilterClick('C# Windows App')} className={filter === 'C# Windows App' ? 'active' : ''}>C# Windows App</button>
          <button onClick={() => handleFilterClick('AI & Automation')} className={filter === 'AI & Automation' ? 'active' : ''}>AI & Automation</button>
          <button onClick={() => handleFilterClick('WordPress')} className={filter === 'WordPress' ? 'active' : ''}>WordPress</button>
       </div>

        {/* Portfolio Items */}
        <div className="container portfolio__container">
          {
           filteredProjects.map((project) => {
                 const {id, image, title, github, demo} = project;
                 const hasGithub = github && github !== '#';
                 const hasDemo = demo && demo !== '#';
                 return (
                     <article
                      key={id}
                      className='portfolio__item'
                      onClick={() => setActiveProject(project)}
                     role="button"
                     tabIndex={0}
                     onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                           e.preventDefault();
                           setActiveProject(project);
                        }
                     }}
                   >
                     <div className="portfolio__item-image">
                        <img src={image} alt={title} loading="lazy" decoding="async" />
                     </div>
                     <h3>{title}</h3>
                     <span className="portfolio__item-view"><FaRegFileAlt /> View case study</span>
                     <div className="portfolio__item-cta" onClick={(e) => e.stopPropagation()}>
                        {hasGithub && (
                           <a href={github} className='btn' target='_blank' rel='noopener noreferrer' title="View on GitHub">
                              <FaGithub />
                           </a>
                        )}
                        {hasDemo && (
                           <a href={demo} className='btn btn-primary' target='_blank' rel='noopener noreferrer' title="Live Demo">
                              <FaExternalLinkAlt />
                           </a>
                        )}
                     </div>
                     </article>
                )
           })
              }
        </div>

       <ProjectModal project={activeProject} onClose={() => setActiveProject(null)} />
     </section>
   )
}

export default Portfolio;
